import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const EmailConfirm = () => {
  const { uidb64, token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('');

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        await axios.get(`https://monkeprogrammer01.pythonanywhere.com/email/confirm/${uidb64}/${token}`);
        setStatus('Email подтверждён успешно!');
        navigate('/login');
      } catch (error) {
        setStatus('Ошибка подтверждения email.');
      }
    };
    confirmEmail();
  }, [uidb64, token, navigate]);

  return <div>{status}</div>;
};

export default EmailConfirm;
